import React, {VFC} from "react";

import {ValueFieldProps} from "@sitecore-jss/sitecore-jss-react-forms/types";

const FieldValidationError: VFC<ValueFieldProps> = (props) => {
  const hasAnyError = !!props.errors?.length;

  return (
    <>
      {hasAnyError && (
        <div className="sitecore-jss-form__error-list">
          {props.errors.map((error) => (
            <p>
              <pfe-icon
                icon="ivg-alert-triangle-line"
                size="16"
                class="sitecore-jss-form__error-list__icon"
              ></pfe-icon>
              {error}
            </p>
          ))}
        </div>
      )}
    </>
  );
};

export default FieldValidationError;
